import { SwitchCardState } from '../../../../../../components/switchCard/types/state';
import { SwitchCardVariantType } from '../../../../../../components/switchCard/types/switchCard';
import { commonStateStyles } from '../commonStyles';
export const getNeutralStyles = (FOUNDATIONS, FONT) => {
    const disabledStyles = {
        cardContainer: {
            background: FOUNDATIONS.color_accent_disabled_bg_200,
        },
        icon: {
            color: FOUNDATIONS.color_accent_disabled_icon_100,
        },
        mainTitle: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
        label: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
        title: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
        description: {
            color: FOUNDATIONS.color_accent_disabled_font_50,
        },
    };
    return {
        [SwitchCardVariantType.NEUTRAL]: {
            [SwitchCardState.DEFAULT]: commonStateStyles(FOUNDATIONS, {}),
            [SwitchCardState.DISABLED]: commonStateStyles(FOUNDATIONS, disabledStyles),
            [SwitchCardState.DISABLED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                ...disabledStyles,
                icon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                },
            }),
            [SwitchCardState.LOADING]: commonStateStyles(FOUNDATIONS, {}),
            [SwitchCardState.SELECTED]: commonStateStyles(FOUNDATIONS, {}),
        },
    };
};
//# sourceMappingURL=neutral.js.map